import { connect } from 'react-redux'
import ItemToolBarComponent from "../components/ItemToolBar";

import {flipItem, nextBtnClicked, deleteItem, swapItemUndo,updateTextStatus, swapItem, groupObjects, unGroupObjects, setPropertyWindow, toggleToolBar, deleteObject, resizeUpdate, toggleCrop, changeBg } from '../actions/index';

const mapStateToProps = (state, ownProps) => ({
    selectedScene   : state.localStore.get("selectedScene"),
    selectedItems   : state.localStore.get("selectedItems"),
    workspaceWidth  : state.project.get("width"),
    workspaceHeight  : state.project.get("height"),
    selectedObjects : state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceItems"]).filter(function(obj, key){return state.localStore.get("selectedItems").keyOf(key) !== undefined;}),
    workspaceChildren : state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceChildren"]),
    duration : state.project.getIn(["scenes", state.localStore.get("selectedScene"), "duration"]),
    playHeadValue : state.project.getIn(["scenes", state.localStore.get("selectedScene"), "playHeadValue"]),
    propertyWindow  : state.localStore.get("propertyWindow"),
    textStatus      : state.localStore.get("textStatus"),
    isWorkspaceTextFocus: state.localStore.get('isWorkspaceTextFocus'),
    transformStatus : state.localStore.get('transformStatus'),
    isToolBarExpanded : state.localStore.get('isToolBarExpanded'),
    zoomFactor : state.localStore.get('zoomFactor'),
    workspaceBounds : state.localStore.get('workspaceBounds'),
    selectionBox : state.localStore.get("selectionBox"),    
    selectedCamera      : state.localStore.get("selectedCamera"),
    swapDetails : state.localStore.get("swapDetails"),
    workspaceStage      : state.localStore.get("workspaceStage"),
    showSlidePanel      : state.localStore.get("showSlidePanel"),
    workspaceCameras : (state.localStore.get("selectedCamera") !== "")?state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceCameras"]):null,
    animakerType : state.localStore.get('animakerType'),
    undoProp    :   state.localStore.get('undoProp'),
    updateItems : state.localStore.get('itemToUpdate'),
    textOffset : state.localStore.get('textOffset'),
    workspaceItems              : state.project.getIn(['scenes',state.localStore.get('selectedScene'), 'workspaceItems']),
    projectData :  state.project
})
       
const mapDispatchToProps = (dispatch, ownProps) => ({
    flipItem        : (data, socket) => {dispatch(flipItem(data, socket))},
    deleteItem      : (data, socket) => {dispatch(deleteItem(data, socket))},
    updateTextStatus: (data) => {dispatch(updateTextStatus(data))},
    swapItem        : (data) => {dispatch(swapItem(data))},
    swapItemUndo        : (data) => {dispatch(swapItemUndo(data))},
    groupObjects    : (data, socket) => {dispatch(groupObjects(data, socket))},
    unGroupObjects  : (data, socket) => {dispatch(unGroupObjects(data, socket))},
    setPropertyWindow  : (data) => {dispatch(setPropertyWindow(data))},
    toggleToolBar:(data, socket) => {dispatch(toggleToolBar(data, socket))},
    changeBg: (data, socket) => { dispatch(changeBg(data, socket)) },
    deleteObject:(type, socket, id, selectedScene, selectedItem) => {
        dispatch(deleteObject(type, socket, id, selectedScene, selectedItem))
    },
    resizeUpdate:(data,socket) => {dispatch(resizeUpdate(data,socket))},
    
    toggleCrop:(data) => {
        dispatch(toggleCrop(data))
      },
      nextBtnClicked : (data) => {
        dispatch(nextBtnClicked(data))
      },
      manageToast: (data) => {
        dispatch({type : "MANAGE_TOAST", data : data})
      }
})

const ItemToolBar = connect(mapStateToProps,mapDispatchToProps)(ItemToolBarComponent)

export default ItemToolBar







// WEBPACK FOOTER //
// ./src/containers/ItemToolBar.js